import { isMobile } from '~/utils';

export const isButtonVisible = (ismobile) => !isMobile(ismobile);
